var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePickerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.173,4.05a.783.783,0,0,0-1.1,0L13.413,14.711,2.73,4.027a.78.78,0,1,0-1.1,1.1L12.311,15.813,1.653,26.47a.778.778,0,0,0,1.1,1.1L13.41,16.916,24.044,27.55a.778.778,0,0,0,1.1-1.1L14.516,15.813,25.173,5.153A.783.783,0,0,0,25.173,4.05Z",
    transform: "translate(-1.4 -3.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerClose);
export default __webpack_public_path__ + "static/media/datePickerClose.43e834da.svg";
export { ForwardRef as ReactComponent };